import { Contacts } from '@/components/Contacts'
import { Footer } from '@/components/Footer'
import { SEO } from '@/components/SEO'
import { SEO_CONFIG } from '@/constants/seo'

export const ContactsPage = () => {
    return (
        <>
            <SEO
                title='Contact Nexly - Get Started with Automated Financial Review'
                description='Contact Nexly to learn how our automated financial statement review software can reduce manual review tasks by 90%. Schedule a demo and get a tailored quote for your firm.'
                canonical={`${SEO_CONFIG.siteUrl}/contacts`}
                ogImage={SEO_CONFIG.ogImage}
            />
            <Contacts/>
            <Footer/>
        </>
    )
}
